import { Controller } from "@hotwired/stimulus";
import { get } from '@rails/request.js'

export default class extends Controller {

  loadErrors(e) {
    e.preventDefault();
    const accessHubId = e.currentTarget.dataset.accesshubid;
    if (!accessHubId) {
      console.error("G7 Access Hub ID is undefined or null");
      return;
    }

    const dialog = document.querySelector('dialog#logBatchErrorsModal');
    get(`/g7_access_hubs/${accessHubId}/log_batch_errors`, {
      responseKind: 'turbo-stream'
    }).catch(error => {
      console.error("Error fetching data:", error);
    });
    dialog.dataset.dialogMode = 'dialog'
    dialog.show();
  }
}
